/**
 * CSS variable set on <html> by the sidepanel bridge when the host reports
 * floating UI (the Sounds plugin's playbar pill) covering the bottom of the
 * embedded viewport. Scroll containers add it to their bottom padding so the
 * last rows can scroll clear of the pill — padding at the end of a scroll
 * container only extends the scrollable extent, so on-screen content never
 * shifts. Unset (0) everywhere outside sidepanel hosts. Import-free so both
 * `.css.ts` files and runtime code can use it.
 */
export const kHostBottomInsetVar = "--labs-host-bottom-inset";

/** Ready-to-use CSS value: the inset, defaulting to 0 when the host never sets it. */
export const kHostBottomInset = `var(${kHostBottomInsetVar}, 0px)`;

export const setHostBottomInset = (px: number): void => {
    document.documentElement.style.setProperty(kHostBottomInsetVar, `${px}px`);
};
